export default __webpack_public_path__ + "static/media/K_wdt_c_cap_0.7c438514.mp3";